let editLinkDrive = function() {
    this.jobsLinkDriveEdit = !this.jobsLinkDriveEdit;
};
export default editLinkDrive;
